import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MapCore } from './MapCore';
import { loadKakaoMapScript } from '../../../../utils/LoadKakaoMap';
import styled from 'styled-components';
const FullscreenMap = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const lat = Number(params.get('lat'));
  const lng = Number(params.get('lng'));
  const groupCategory = params.get('groupCategory');
  const [isExpanded, setIsExpanded] = useState(false);

  let geom = [];

  try {
    const raw = params.get('geom');
    geom = raw ? JSON.parse(decodeURIComponent(raw)) : [];
  } catch (e) {
    console.error('geom 파싱 에러:', e);
  }

  useEffect(() => {
    loadKakaoMapScript()
      .then(() => setIsExpanded(true))
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    if (!isExpanded) return;

    const timer = setTimeout(() => {
      if (window.kakao && window.kakao.maps) {
        const mapContainer = document.getElementById('InnerMap');
        if (mapContainer && mapContainer.children.length > 0) {
          const mapEl = mapContainer.children[0] as HTMLElement;
          const mapInstance = (mapEl as any).__kakaoMapInstance;

          if (mapInstance && typeof mapInstance.relayout === 'function') {
            mapInstance.relayout();
          }
        }
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [isExpanded]);

  if (!lat || !lng) {
    return <div>지도를 불러올 수 없습니다.</div>;
  }
console.log(params.get('geom'));
  return (
    <Wrapper>
      <TitleWrapper>
        <BackButton onClick={() => window.close()}>
          <img src="/assets/images/icon/Button_Back.svg" alt="닫기" />
        </BackButton>
        <TitleBox>현장 위치</TitleBox>
      </TitleWrapper>

      <MapContainer id="StateMap" expanded={isExpanded}>
        {isExpanded && (
          <MapCore
            id="InnerMap"
            lat={lat}
            lng={lng}
            groupCategory={groupCategory ?? ''}
            geom={geom}
            roadView={false}
          />
        )}
      </MapContainer>

      <BottomWrapper>
        <BottomContainer>
          <Tab>전자지도</Tab>
          <Tab>지적편집도</Tab>
          <Tab>로드뷰</Tab>
        </BottomContainer>
      </BottomWrapper>
    </Wrapper>
  );
};

export default FullscreenMap;


const Wrapper = styled.div``;

const TitleWrapper = styled.div`
  display: flex;
  height: 56px;
  align-items: center;
  padding: 4px 8px;
  color: #222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
`;

const BackButton = styled.div`
  cursor: pointer;
`;

const TitleBox = styled.div``;

const BottomWrapper = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  bottom: 80px;
`
const BottomContainer = styled.div`
  margin: 0 auto;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  border-radius: 8px;
  background: #ffffff;
  flex-wrap: nowrap;
`;

const Tab = styled.div`
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: Spoqa Han Sans Neo;
  line-height: 20.3px;
  word-wrap: break-word;
  color: #989BA2;
  white-space: nowrap;
`;

interface MapContainerProps {
  expanded?: boolean;
}

const MapContainer = styled.div<MapContainerProps>`
  width: 100%;
  height: ${({ expanded }) => (expanded ? '100vh' : '164px')};
 position: relative;
  top: 0;
  left: 0;
  z-index: 1;
  text-align: center;
  display: flex;

  [id^='_box_util_'] {
    display: none !important;
  }
`;